export const cvData = {
  "name": "Luis Felipe Cubero Vargas",
  "email": "lucubvar@gmail.com",
  "phone": "+(506)88758670",
  "website": "https://luisfelipecuberov.com/",
  "socialNetworks": [
    {
      "network": "LinkedIn",
      "username": "luisfelipecuberovargas"
    },
    {
      "network": "GitHub",
      "username": "fecuva"
    }
  ],
  "welcomeMessage": "",
  "experience": [
    {
      "company": "Datasite",
      "position": "Sr Data Engineer",
      "start_date": "2024-04",
      "location": "Heredia, CR",
      "highlights": [
        "Architected and owned a highly available Airflow 3.x platform on Kubernetes, designing a Helm-based deployment with multi-replica schedulers and API servers, dedicated DAG processors, and triggerers to support production-grade orchestration, fault tolerance, and horizontal scalability.",
        "Designed a Git-based DAG bundle architecture to replace traditional git-sync, enabling controlled refresh intervals, cleaner environment promotion, and improved operational scalability while standardizing DAG lifecycle management across teams.",
        "Established platform-level orchestration patterns and governance, defining standardized DAG structures, branching strategies (incremental vs. full-refresh), and configuration/variables management to improve reliability, reduce operational risk, and enable consistent delivery across multiple data domains."
      ]
    },
    {
      "company": "Rhythm Energy",
      "position": "Sr Data Engineer Consultor",
      "start_date": "2022-09",
      "end_date": "2025-08",
      "location": "Houston, TX (remote)",
      "highlights": [
        "Led the design and implementation of Databricks-based data platforms, using Databricks Asset Bundles, Jobs, and Workflows to orchestrate complex ELT pipelines across ingestion, analytics, and risk domains in production environments.",
        "Built and optimized large-scale Spark/Delta Lake workloads in Python and SQL, including parameterized notebook pipelines and reusable ingestion frameworks, tuning cluster configs, autoscaling, and storage patterns for performance, reliability, and cost efficiency.",
        "Provided senior technical leadership on Databricks best practices, covering environment and workspace strategy (dev/prod, service principals, permissions), CI/CD-driven bundle deployments, and standardized pipeline patterns adopted across multiple teams."
      ]
    },
    {
      "company": "Steppechange",
      "position": "Sr Data Engineer Consultor",
      "start_date": "2023-04",
      "end_date": "2024-06",
      "location": "San Francisco, CA (remote)",
      "highlights": [
        "Architected end-to-end data platform with Apache Airflow orchestrating production DAGs, integrating Facebook Ads API, Google Display & Video 360, and BigQuery to automate reporting pipelines across all business units.",
        "Designed metadata-driven data quality framework with automated validation and state management, ensuring reliability across asynchronous report processing and BigQuery ingestion workflows.",
        "Led data architecture redesign implementing CI/CD practices with modular Python utilities and parameterized DAG configurations, reducing pipeline development time while enabling scalable analytics"
      ]
    },
    {
      "company": "Migo",
      "position": "Sr Data Engineer",
      "start_date": "2021-06",
      "end_date": "2023-03",
      "location": "San Francisco, CA (remote)",
      "highlights": [
        "Creation of Data Pipelines using Airflow, K8 and AWS services to stream external data to our data warehouse (Snowflake).",
        "ETL and Data Pipelines to satisfy Marketing and Data Science teams",
        "Creation of model featurization process to speed up Data Science’s modeling and analysis"
      ]
    },
    {
      "company": "Hangar Worldwide",
      "position": "Data Scientist",
      "start_date": "2019-02",
      "end_date": "2021-05",
      "location": "Heredia, CR",
      "highlights": [
        "Creation AI models following CRISP-DM framework to generate insights based on client's concern about their business",
        "Build ETL process for migration of data services to cloud services using ETL tools as Matillion and Azure and Snowflake",
        "Created a model using FB prophet that predicted lead counts for an insurance client 6 weeks in advance with 80% accuracy"
      ]
    }
  ]
}
